/* eslint-disable no-console */

import { register } from 'register-service-worker'
import store from '@/store'

// Behöver ha dessa metoderna för att webbläsarna ska godkänna appen som PWA
// Skriver just nu bara ut, men kanske kan visa mer i UI framöver
// Ska aldrig köras i testmiljö för det slår ut hot-reload
// Paketet har automatisk rensning av serviceworkers i testmiljö
if (process.env.NODE_ENV === 'production') {
  // Intervall för automatisk uppdateringskontroll (6 timmar)
  const SIX_HOURS_IN_MS = 6 * 60 * 60 * 1000

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'Appen serveras från cachen av en service worker.\n' +
        'För mer information, besök https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker har registrerats.')
      // Kontrollera efter uppdateringar var 6:e timme
      setInterval(() => {
        console.log('Kör schemalagd uppdateringskontroll')
        registration.update()
      }, SIX_HOURS_IN_MS)
    },
    cached () {
      console.log('Innehållet har cachats för offline-användning.')
    },
    updatefound () {
      console.log('Nytt innehåll laddas ner.')
    },
    updated () {
      console.log('Nytt innehåll är tillgängligt; vänligen uppdatera.')
      // Sätt flagga för att visa uppdateringsindikator
      store.commit('SET_HAS_WAITING_UPDATE', true)
    },
    offline () {
      console.log('Ingen internetanslutning hittades. Appen körs i offline-läge.')
    },
    error (error) {
      console.error('Fel under registrering av service worker:', error)
    }
  })
}

// Exporterad funktion för manuell uppdateringskontroll
export async function checkForUpdates () {
  if (!('serviceWorker' in navigator)) {
    return { hasUpdate: false, reason: 'no-support' }
  }

  try {
    const registration = await navigator.serviceWorker.getRegistration()
    if (!registration) {
      return { hasUpdate: false, reason: 'no-registration' }
    }

    // Kontrollera om det redan finns en väntande uppdatering
    if (registration.waiting) {
      store.commit('SET_HAS_WAITING_UPDATE', true)
      return { hasUpdate: true }
    }

    // Tvinga fram en uppdateringskontroll
    await registration.update()

    // Vänta kort på att se om en uppdatering hittades
    return new Promise((resolve) => {
      // Om det finns en installing worker, bevaka den
      if (registration.installing) {
        const worker = registration.installing
        worker.addEventListener('statechange', () => {
          if (worker.state === 'installed') {
            store.commit('SET_HAS_WAITING_UPDATE', true)
            resolve({ hasUpdate: true })
          }
        })
        // Timeout ifall statechange aldrig triggas
        setTimeout(() => resolve({ hasUpdate: false, reason: 'timeout' }), 5000)
      } else if (registration.waiting) {
        store.commit('SET_HAS_WAITING_UPDATE', true)
        resolve({ hasUpdate: true })
      } else {
        // Ingen uppdatering hittades direkt, vänta lite
        setTimeout(() => {
          if (registration.waiting || registration.installing) {
            store.commit('SET_HAS_WAITING_UPDATE', true)
            resolve({ hasUpdate: true })
          } else {
            resolve({ hasUpdate: false, reason: 'up-to-date' })
          }
        }, 2000)
      }
    })
  } catch (error) {
    console.error('Fel vid uppdateringskontroll:', error)
    return { hasUpdate: false, reason: 'error' }
  }
}
